import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ItemService from "../../../services/customer_appCommonService";

const GoogleMapComponentFromTo = (props) => {
  const [fromAddress, setFromAddress] = useState("");
  const [toAddress, setToAddress] = useState("");
  const [fromCoords, setFromCoords] = useState(null);
  const [toCoords, setToCoords] = useState(null);
  const [distance, setDistance] = useState(null);
  const [duration, setDuration] = useState(null);

  const fromRef = useRef(null);
  const toRef = useRef(null);

  useEffect(() => {
    loadGoogleMapsScript(() => {
      initAutocomplete(fromRef, setFromAddress, setFromCoords);
      initAutocomplete(toRef, setToAddress, setToCoords);
    });

    // if (props?.passmapdata) {
    //   setToAddress(props?.passmapdata[0]?.projectLocation);
    //   setToCoords(props?.passmapdata[0]?.fromToCoords?.destinations);
    //   setDistance(props?.passmapdata[0]?.distance);
    //   setDuration(props?.passmapdata[0]?.duration);
    // }
    if (props?.passmapdata && props.passmapdata[0]) {
      const data = props.passmapdata[0];
      setFromAddress(data.plantAddress || "");
      setFromCoords(data.fromToCoords?.origins || null);
      setToAddress(data.projectLocation || "");
      setToCoords(data.fromToCoords?.destinations || null);
      setDistance(data.distance || null);
      setDuration(data.duration || null);
    }
  }, [props]);

  const loadGoogleMapsScript = (callback) => {
    if (window.google) {
      callback();
      return;
    }
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDfuYFHr0Odqv0EMjVS71uf0tVsP30n1qw&libraries=places";
    script.async = true;
    script.onload = callback;
    document.body.appendChild(script);
  };

  const initAutocomplete = (ref, setAddress, setCoords) => {
    if (!window.google) return;
    const autocomplete = new window.google.maps.places.Autocomplete(ref.current);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        setAddress(place.formatted_address);
        setCoords({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });
        setDuration(null);
        setDistance(null);
      }
    });
  };

  const getDistanceAndTime = async () => {
    if (!fromCoords || !toCoords) return;

    const obj = {
      origins: fromCoords,
      destinations: toCoords,
    };

    try {
      const data = await ItemService.mapDistance(obj);

      if (data.rows && data.rows[0].elements[0].status === "OK") {
        const dist = data.rows[0].elements[0].distance.text;
        const dur = data.rows[0].elements[0].duration.text;
        setDistance(dist);
        setDuration(dur);

        const param = {
          projectIndex: props?.projectIndex,
          plantAddress: fromAddress,
          projectLocation: toAddress,
          distance: dist,
          duration: dur,
          fromToCoords: obj,
        };

        props.getmapdata(param);
      } else {
        setDistance("Error: " + data.rows[0].elements[0].status);
        setDuration("Error: " + data.rows[0].elements[0].status);
      }
    } catch (error) {
      console.error("Distance API Error:", error);
      setDistance("Error fetching data");
      setDuration("Error fetching data");
    }
  };

  return (
    <Row className="pt-2 pb-4">
      {/* From Address */}
      <Col xs={12} lg={6} className="commTopButtonRightLeftPadding">
        <p className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion mb-0">
          From Address
        </p>
        <input
          type="text"
          placeholder="Enter source address..."
          ref={fromRef}
          value={fromAddress}
          onChange={(e) => setFromAddress(e.target.value)}
          style={{
            width: "90%",
            padding: "10px",
            fontSize: "16px",
            marginBottom: "10px",
          }}
          disabled={props?.editstatus}
        />
      </Col>

      {/* To Address */}
      <Col xs={12} lg={6} className="commTopButtonRightLeftPadding">
        <p className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion mb-0">
          To Address
        </p>
        <input
          type="text"
          placeholder="Enter destination address..."
          ref={toRef}
          value={toAddress}
          onChange={(e) => setToAddress(e.target.value)}
          style={{
            width: "90%",
            padding: "10px",
            fontSize: "16px",
            marginBottom: "10px",
          }}
          disabled={props?.editstatus}
        />
      </Col>

      {/* Button to Get Distance */}
      {!props?.editstatus && (
        <Col xs={12} className="text-center mt-2">
          <button
            onClick={getDistanceAndTime}
            className="btnTable"
            disabled={props?.editstatus}
          >
            Get Distance & Time
          </button>
        </Col>
      )}

      {/* Output Distance and Time */}
      {distance && duration && (
        <Col xs={12} className="text-center mt-4">
          <p className="p-0 m-0">
            <span className="fw-bold">Note: </span>Distance shown is approximate. Actual may vary slightly.
          </p>
          <h4 className="bg-table-status bg-table-info-status mt-1">
            Distance: {distance} | Travel Time: {duration}
          </h4>
        </Col>
      )}

      {/* Show Map */}
      {fromCoords && toCoords && (
        <Col xs={12} className="mt-4">
          <iframe
            title="Route Map"
            width="100%"
            height="400"
            style={{ border: 0 }}
            src={`https://www.google.com/maps/embed/v1/directions?key=AIzaSyDfuYFHr0Odqv0EMjVS71uf0tVsP30n1qw&origin=${fromCoords.lat},${fromCoords.lng}&destination=${toCoords.lat},${toCoords.lng}&mode=driving`}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Col>
      )}
    </Row>
  );
};

export default GoogleMapComponentFromTo;
